// extracted by css-extract-rspack-plugin
export default {"callDuration":"callDuration-HAmLA8","input":"input-qFTfZU"};